import { ENV } from '../const';

// Some logic to get the env name
export function getEnv() {
  return ENV.names.develop;
}

export function isDev(env?: any) {
  if (!env) {
    env = getEnv();
  }

  return env && env === ENV.names.develop;
}

export function isStagingDeployment() {
  return process.env.REACT_APP_ENV === ENV.names.staging;
}

export function isProductionDeployment() {
  return process.env.REACT_APP_ENV === ENV.names.production;
}
